import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from '../../../admin.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/utils/loader.service';

interface DialogData {
  bDisabled: boolean
}

@Component({
  selector: 'app-painting',
  templateUrl: './painting.component.html',
  styleUrls: ['./painting.component.scss']
})
export class PaintingComponent implements OnInit {

  proofUploaded: boolean;
  uploaded_file_name="";
  order_id: any;
  invoice_id: any;
  invoice_details: any;
  shipmentNo: any;
  paintingFilevalue: any;
  is_Paintingchecked : boolean = false;
  vendorOrderItemdata: any;
  payment_file: any;
  uploadFilepaths: any;
  fileUploadLoading: boolean = false;

  constructor(   public dialogref: MatDialogRef<PaintingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private toastr: ToastrService,
    private loaderService: LoaderService) { }

  private paymentfilesControl = new FormControl(null, FileUploadValidators.filesLimit(1));
  public demoForm = new FormGroup({
    files: this.paymentfilesControl
  });
  
  ngOnInit(): void {
    this.vendorOrderItemdata = this.data["data"];
    this.order_id = this.data["order_id"];
    this.invoice_id = this.data["invoice_id"];
    if(this.vendorOrderItemdata?.is_painting) {
    this.is_Paintingchecked = Boolean(JSON.parse(this.vendorOrderItemdata?.is_painting));
    }
    if(this.is_Paintingchecked) {
      let fileval = this.vendorOrderItemdata?.painting_file.split('/');
      this.uploaded_file_name = fileval[fileval.length -1];
   
      // this.uploadFilepaths = this.vendorOrderItemdata?.painting_file ;
      // this.uploaded_file_name = fileval;
      this.proofUploaded = true ;
    }
    this.paintingFile();
  }

  submit()
  {
    this.loaderService.display(true);
    let formData = new FormData();

     formData.append('vendor_order_items[painting]', this.demoForm.value.files[0]);
     formData.append('vendor_order_items[is_painting]',this.is_Paintingchecked.toString());


    this.adminService.addPainting(this.order_id,this.vendorOrderItemdata?.vendor_item_id, formData).subscribe(
      res => {
        this.toastr.success('Painting file has been Submitted', 'Success');
        this.loaderService.display(false);
        this.close();
      },
      err => {
        this.toastr.error('Something went Wrong', 'Error');
        this.loaderService.display(false);
        this.close();
      }

    );
  }

  paintingFile() {
    const file = this.demoForm.get('files')
    file.valueChanges.subscribe(
      res => {
        this.payment_file = res[0]
        console.log(this.payment_file)
        
      }
    )
  }

  close() {
    this.dialogref.close();
  }

  onchangePaintingValue(evt)
  {
    
  }

  removeFile()
  {
    this.uploaded_file_name = '';
  }
  downloadUrl(){
    
  //  let path = 'admin/partner-orders/painting/' + this.vendorOrderItemdata?.vendor_item_id + '/' + this.uploaded_file_name;
    this.adminService.downloadFile(this.vendorOrderItemdata?.vendor_item_id,this.uploaded_file_name).subscribe(
      (res: any) => {
        window.open(res.vendor_painting_url, "_blank");
        this.close();
      },
      err => {
        this.toastr.error('Something went Wrong', 'Error');
        this.close();
      }

    );
    
  }

}
